import { customerBaseApi } from "@/react/services/api";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { KEY } from "@/react/components/table/useTableMutations";
import { createNotifier } from "@/react/notifications";
import { HttpMethods } from "@/react/http";

const icfUrl = (pbxId) => `pbxes/${pbxId}/serviceicf`;

export const icfApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getIcfAndExtensions: build.query({
      query: ({ pbxId }) => ({
        url: icfUrl(pbxId),
        method: HttpMethods.GET,
      }),
    }),
    updateIcfAndExtensions: build.mutation({
      query: ({ pbxId, icf }) => ({
        url: icfUrl(pbxId),
        method: HttpMethods.POST,
        body: icf,
      }),
    }),
  }),
});

export const {
  useGetIcfAndExtensionsQuery,
  useUpdateIcfAndExtensionsMutation,
} = icfApi;

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
  idKey,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: idKey,
    idKey: KEY,
    notifyContent: createNotifier("update", "extension"),
  });
